/**
 * アプリ生成における上限値の定数定義
 *
 * TODO(REQ-2640): 後でAPI連携に切り替える
 * GET /limits/app-generation → { maxApps: 50, maxFieldsPerApp: 240, maxCustomizationsPerApp: 10 }
 */

/** アプリテーブルに登録できるアプリの最大数 */
export const MAX_APPS = 50;

/** アプリごとに設定できるフィールドの最大数（システムフィールド除外） */
export const MAX_FIELDS_PER_APP = 240;

/** アプリごとに設定できるカスタマイズの最大数 */
export const MAX_CUSTOMIZATIONS_PER_APP = 10;
